import React, {useState} from 'react'
import Input from "../../../../generic/dataEntry/Input/Input"
import Button from "../../../../generic/buttons/Button/Button"
import {useAppDispatch, useAppSelector} from "../../../../../hooks/redux"
import {login} from "../../../../../store/actions/authActions"
import {authSlice} from "../../../../../store/slices/authSlice"
import {useFormik} from "formik"
import logo from "../../../../../assets/images/crm-logo.png"
import {useNavigate} from "react-router-dom"
import classes from './Login.module.scss'
import ModalForgottenPassword from "../../../../blocks/modals/ModalForgottenPassword"
import ModalSuccess from "../../../../blocks/modals/ModalSuccess/ModalSuccess"

export default function Login() {

  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const {error, isLoginProcess} = useAppSelector(state => state.auth)
  const [modalForgottenPasswordShown, modalForgottenPasswordToggle] = useState(false)
  const [modalEmailSentSuccessShown, modalEmailSentSuccessToggle] = useState(false)

  const clearError = () => {
    dispatch(authSlice.actions.clearError())
  }

  const {values, touched, handleChange, handleSubmit} = useFormik({
    initialValues: {
      email: '',
      password: ''
    },
    onSubmit: async () => {
      const isAuth = await dispatch(login(values))
      if (isAuth) {
        navigate("/")
      }
    }
  })

  const modalForgottenPassword = modalForgottenPasswordShown &&
    <ModalForgottenPassword
      modalToggle={modalForgottenPasswordToggle}
      emailSentSuccess={modalEmailSentSuccessToggle}
    />

  const modalEmailSentSuccess = modalEmailSentSuccessShown &&
    <ModalSuccess
      close={() => modalEmailSentSuccessToggle(false)}
      title={"Письмо отправлено Вам на почту!"}
    />

  return (
    <div className={classes.wrap}>
      <div className={classes.form}>
        <div className={classes.logo}><img src={logo} alt=""/></div>
        <h1 className={classes.form_title}>Авторизация</h1>
        <form
          onSubmit={handleSubmit}
        >
          <div className={classes.form_field}>
            <Input
              value={values.email}
              onChange={handleChange}
              name={'email'}
              className={classes.form_field}
              required={true}
              type={'text'}
              label={'E-mail'}
              valid={!error.email}
              errorMessage={error.email}
              touched={touched.email}
              onInput={clearError}
              shouldValidate
              theme={"default"}
            />
          </div>
          <div className={classes.form_field}>
            <Input
              value={values.password}
              onChange={handleChange}
              name={'password'}
              className={classes.form_field}
              required={false}
              type={'password'}
              label={'Пароль'}
              valid={!error.password}
              errorMessage={error.password}
              touched={touched.password}
              onInput={clearError}
              shouldValidate
              theme={"default"}
            />
          </div>
          <div className={classes.form_bottom}>
            <Button
              type={'submit'}
              className={classes.form_submit}
              isLoading={isLoginProcess}
              disabled={isLoginProcess}
            >
              Войти
            </Button>
            <div className={classes.form_links}>
              <span
                className={classes.form_link}
                onClick={() => modalForgottenPasswordToggle(true)}
              >Забыли пароль?</span>
            </div>
          </div>
        </form>
      </div>
      {modalForgottenPassword}
      {modalEmailSentSuccess}
    </div>
  )
}